import { defineComponent as _defineComponent } from 'vue'
import { SelfUserInfo } from "./GeneralUserView.vue";

type Props = {
  item: SelfUserInfo;
};
type UserInfoHeader = {
  text: string;
  value: keyof SelfUserInfo;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'GeneralUserInfoTable',
  props: {
    item: null
  },
  setup(__props: any) {



const headers: UserInfoHeader[] = [
  { text: "社員コード", value: "code" },
  { text: "社員名", value: "name" },
  { text: "社員名カナ", value: "kanaName" },
  { text: "性別", value: "sex" },
  { text: "生年月日", value: "birthDay" },
  { text: "権限", value: "authority" }
];

return { __sfc: true,headers }
}

})